module.exports = __webpack_public_path__ + "static/media/white_logo_nsc.b2b900b1.png";